import { Menu, Share } from "lucide-react";
import { ZeusBolt } from "@/components/ZeusBolt";
import { ModelSelector } from "./ModelSelector";

interface ChatHeaderProps {
  hasConversation: boolean;
  onMenuToggle?: () => void;
  showMenu?: boolean;
}

export function ChatHeader({ hasConversation, onMenuToggle, showMenu }: ChatHeaderProps) {
  return (
    <header className="flex items-center justify-between h-12 px-3 sm:px-4 border-b border-border/50 shrink-0">
      <div className="flex items-center gap-2">
        {showMenu && onMenuToggle && (
          <button
            onClick={onMenuToggle}
            className="p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors"
            aria-label="Toggle sidebar"
          >
            <Menu className="h-5 w-5" />
          </button>
        )}
        {!hasConversation && (
          <div className="flex items-center gap-2 mr-2">
            <ZeusBolt size={18} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Zeus</span>
          </div>
        )}
        <ModelSelector />
      </div>
      <button className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-sm text-muted-foreground hover:text-foreground hover:bg-surface-hover transition-colors">
        <Share className="h-3.5 w-3.5" />
        Share
      </button>
    </header>
  );
}
